// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import ReactGA from 'react-ga';

window.Upload = {};

ReactGA.initialize(process.env.GATSBY_GA_ACCOUNT);